const mediaItems = [
  {
    title: '热门动作大片推荐',
    desc: '肾上腺素飙升的高分动作片合集，高清画质带来极致观影体验',
    tag: '动作精选',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20atmosphere%20with%20dramatic%20warm%20golden%20lighting%2C%20cinematic%20explosion%20silhouette%20against%20dark%20background%2C%20intense%20film%20poster%20style%2C%20rich%20amber%20and%20crimson%20tones%2C%20no%20text%2C%20no%20people%20faces%2C%20movie%20theater%20dramatic%20vibe&width=600&height=400&seq=media-01-action&orientation=landscape',
  },
  {
    title: '高分悬疑剧集特辑',
    desc: '烧脑悬疑高分剧集全收录，反转不断的精彩故事等你来追',
    tag: '悬疑烧脑',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20cinematic%20scene%20with%20soft%20fog%20and%20warm%20amber%20light%20beam%2C%20film%20noir%20atmosphere%2C%20suspenseful%20shadow%20play%2C%20elegant%20composition%2C%20deep%20contrast%20with%20golden%20highlights%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=media-02-thriller&orientation=landscape',
  },
  {
    title: '经典爱情电影回顾',
    desc: '最动人的爱情故事高清合集，温暖治愈的高分爱情片一次看够',
    tag: '浪漫经典',
    img: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20cinematic%20atmosphere%20with%20warm%20golden%20sunset%20light%2C%20elegant%20film%20grain%20texture%2C%20dreamy%20bokeh%20background%2C%20classic%20movie%20vibe%2C%20gentle%20amber%20and%20rose%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=media-03-romance&orientation=landscape',
  },
  {
    title: '爆笑喜剧片大合集',
    desc: '让你从头笑到尾的高分喜剧电影，解压放松的最佳选择',
    tag: '轻松一刻',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20cinematic%20scene%20with%20warm%20vibrant%20colors%2C%20playful%20abstract%20composition%2C%20theater%20stage%20lights%20in%20golden%20amber%2C%20happy%20and%20lively%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20film%20poster%20style&width=600&height=400&seq=media-04-comedy&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              编辑精心挑选的高清影视内容，总有一部适合你
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/40 transition-all cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/90 text-background-50">
                      <i className="ri-play-fill text-xl ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}